// extracted by mini-css-extract-plugin
export var body = "notification-module--body--39ac3";
export var description = "notification-module--description--7dbfc";
export var fill = "notification-module--fill--3d075";
export var root = "notification-module--root--2b24f";
export var slideDown = "notification-module--slideDown--8f6cb";
export var title = "notification-module--title--5e153";